exports.tokenKey = "token";
exports.logoutLabel = "Logout";
exports.logoLabel = "logo";
exports.test = "test";
exports.viewProfileLabel = "View Profile";
exports.dynamicLogoCall = "bx_block_settings/dynamic_contents";
exports.permissionApi = "account_block/employees";
exports.permissionApiMethod = "GET";
exports.dynamicLogoApiContentType = "application/json";
exports.dynamicLogoApiMethodType = "GET";
exports.userShortNameKey = "userShortName";
exports.cancelButton = "Cancel";
exports.textMessage = "Are you sure you want to deactivate the"
exports.textMessageDelete = "Are you sure you want to delete the"
exports.unDoneMessage = "This process cannot be undone"
exports.confirmDeactiveMessage = "has been deactivated successfully";
exports.applyButton = "Apply";
exports.clearButton = "Clear All";
exports.ascendingButton = "Ascending";
exports.descendingButton = "Descending";
exports.activateButton = "Activate";
exports.deActivateButton = "Deactivated";
exports.onlineButton = "Online";
exports.offlineButton = "Offline";
exports.sectionText = "Section Name";
exports.statusText = "Status";
exports.orderText = "Order";
exports.filterTitle = "Filters";
exports.upchargeText = "Upcharge";
exports.upchargeError = "Please select at least one option for upcharge.";
exports.preferenceText = "Preference";
exports.preferenceError = "Please select at least one option for preference.";
exports.placeholderText = "Type to Select"

exports.getNotificationCountEndPoint = "/bx_block_notifications/notifications/notification_count";
exports.topSellingFavoriteItemsEndPoint = "bx_block_dashboard/top_selling_items/top_selling_favorite_item";
exports.getFavoriteItemsEndPoint = "bx_block_dashboard/top_selling_items/get_top_selling_favorite";
exports.customizeProductEndPoint = "bx_block_catalogue/catalogues/products_list?page_no=1&per_page=600&price_list_id=1&for_pos=true";
exports.productGroupListEndPoint = "/bx_block_catalogue/catalogues/parent_products_dropdown";
exports.topSellingItemsEndPoint = "bx_block_dashboard/top_selling_items/top_selling_item";

exports.getMethod = "GET";